import React from "react";
import styles from "./info-banner.module.scss";
import InfoIcon from "@assets/icons/InfoIcon";

const InfoBanner = ({ open, setIsOpen }) => {
  return open ? (
    <div className={styles.banner}>
      {/*<div className={styles.bannerHeader}>*/}
      {/*  <p>*/}
      {/*    Scheduled Maintenance In Progress: 04 Oct, 2024 12:00PM - 5:00PM EST*/}
      {/*  </p>*/}
      {/*</div>*/}
      <InfoIcon />
      {
        <p>
          Climate Finance Copilot is becoming Climate Finance Intelligence. We
          are retiring Climate Finance Copilot to bring you the world's first AI
          engineered platform built specifically for precedent-based project
          preparation.
          <br />
          <br />
          Release Date: February 9, 2026.
          <br />
          <br />
          Need immediate support or a Concept Note evaluation during the
          transition? Contact us at admin@janusadvisoryinc.com
        </p>
      }
    </div>
  ) : (
    <></>
  );
};

export default InfoBanner;
